import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("#build/app.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("#build/login.vue").then(m => m.default || m))
}